"use strict";
'app public';

var _interopRequireDefault = require("@babel/runtime-corejs3/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var Misc = _interopRequireWildcard(require("@/helpers/Misc"));
var _GlobalApi = _interopRequireDefault(require("@/libs/GlobalApi"));
var _Html = _interopRequireDefault(require("@/libs/renderers/Html"));
var _MessageParser = _interopRequireDefault(require("@/libs/MessageParser"));
var _UserAvatar = _interopRequireDefault(require("./UserAvatar"));
var _AwayStatusIndicator = _interopRequireDefault(require("./AwayStatusIndicator"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function (e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, default: e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (const t in e) "default" !== t && {}.hasOwnProperty.call(e, t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, t)) && (i.get || i.set) ? o(f, t, i) : f[t] = e[t]); return f; })(e, t); }
var _default = exports.default = {
  components: {
    UserAvatar: _UserAvatar.default,
    AwayStatusIndicator: _AwayStatusIndicator.default
  },
  props: ['network', 'buffer', 'user', 'sidebarState'],
  data() {
    return {
      self: this,
      whoisRequested: false,
      whoisLoading: false,
      pluginUiButtonElements: _GlobalApi.default.singleton().userboxButtonPlugins,
      pluginUiWhoisElements: _GlobalApi.default.singleton().userboxWhoisPlugins
    };
  },
  computed: {
    // Channel modes differ on some IRCds so get them from the network options
    availableChannelModes() {
      let availableModes = [];
      let prefixes = this.network.ircClient.network.options.PREFIX;
      // Libellés alignés sur les badges de rôle de la nicklist (cf. README §10).
      let knownPrefix = {
        q: 'LEADER',
        a: 'ADMIN',
        o: 'STAFF',
        h: 'MODO',
        v: 'VIP'
      };
      prefixes.forEach(prefix => {
        let mode = prefix.mode;
        if (knownPrefix[mode]) {
          availableModes.push({
            mode: mode,
            description: knownPrefix[mode]
          });
        }
      });
      return availableModes;
    },
    areWeAnOp() {
      if (!this.buffer) {
        return false;
      }
      return this.buffer.isUserAnOp(this.buffer.getNetwork().nick);
    },
    realname() {
      return (this.user.realname || '').trim();
    },
    formattedRealname() {
      let blocks = (0, _MessageParser.default)(this.realname, {
        extras: false
      });
      let content = (0, _Html.default)(blocks, false);
      return content;
    },
    // ── ASL (âge • sexe • lieu) — mêmes computeds que NicklistUser.vue ──────
    aslAge() {
      return this.user.asl && this.user.asl.a ? `${this.user.asl.a} ans` : '';
    },
    aslLocation() {
      return this.user.asl && this.user.asl.l ? this.user.asl.l : '';
    },
    aslMetaLine() {
      return this.aslAge || this.aslSexLabel || this.aslLocation;
    },
    aslSexKey() {
      return this.user.asl && this.user.asl.s ? this.user.asl.s : '';
    },
    aslSexLabel() {
      if (!this.aslSexKey) {
        return '';
      }
      const labels = {
        _male: 'Homme',
        _female: 'Femme',
        _homme: 'Homme',
        _fehomme: 'Femme'
      };
      return labels[this.aslSexKey] || this.aslSexKey.replace(/^_/, '');
    },
    aslSexClass() {
      const sex = (this.aslSexKey || '').toLowerCase();
      // « femme » ne contient ni « female » ni « male » → test explicite ;
      // le test femelle passe avant le mâle (« fehomme » contient « homme »).
      if (sex.includes('female') || sex.includes('femme') || sex.includes('fehomme')) {
        return 'female';
      }
      if (sex.includes('male') || sex.includes('homme')) {
        return 'male';
      }
      return 'other';
    },
    isUserOnBuffer() {
      if (!this.buffer) {
        return false;
      }
      if (!this.user.buffers[this.buffer.id]) {
        // Probably switched buffer while the userbox was open
        return false;
      }
      return true;
    },
    userMode: {
      get() {
        if (!this.buffer) {
          return '';
        }
        let userBufferInfo = this.user.buffers[this.buffer.id];
        if (!userBufferInfo) {
          // Probably switched buffer while the userbox was open
          return '';
        }
        let modes = userBufferInfo.modes;
        return modes.length > 0 ? modes[0] : '';
      },
      // Switch the current user mode for the new one
      set(newVal) {
        let client = this.network.ircClient;
        let oldVal = this.userMode;
        let changes = [];
        let targets = [];
        if (oldVal) {
          changes.push('-' + oldVal);
          targets.push(this.user.nick);
        }
        if (newVal) {
          changes.push('+' + newVal);
          targets.push(this.user.nick);
        }
        let params = ['MODE', this.buffer.name, changes.join('')].concat(targets);
        client.raw(params);
      }
    },
    // Salons de l'utilisateur (WHO), avec drapeau "commun" (l'utilisateur COURANT
    // y est aussi). Rendus en pilules sous l'ASL — cf. template.
    userChannelsList() {
      if (!this.user.whois || !this.user.whois.channels) {
        return [];
      }
      // Salons où JE suis présent (join) → repère les salons en commun.
      let mine = Object.create(null);
      this.network.buffers.forEach(b => {
        if (b.isChannel && b.isChannel() && b.joined) {
          mine[b.name.toLowerCase()] = true;
        }
      });
      let seen = Object.create(null);
      let list = [];
      this.user.whois.channels.trim().split(/\s+/).forEach(raw => {
        // Retire les préfixes de mode (@, +, %, ~…) devant le nom du salon.
        let name = raw.replace(/^[^#&]*/, '');
        let key = name.toLowerCase();
        if (!name || seen[key]) {
          return;
        }
        seen[key] = true;
        list.push({
          name,
          common: !!mine[key]
        });
      });
      list.sort((a, b) => Misc.strCompare(a.name, b.name));
      return list;
    },
    // Salons EN COMMUN (l'utilisateur courant y est aussi) → « Salon(s) commun(s) »
    // sous l'ASL (pilules lumineuses).
    commonChannels() {
      return this.userChannelsList.filter(c => c.common);
    },
    // Autres salons de l'utilisateur (pas en commun) → bloc whois (pilules grisées).
    otherChannels() {
      return this.userChannelsList.filter(c => !c.common);
    },
    isSelf() {
      return this.user === this.network.currentUser();
    }
  },
  watch: {
    user() {
      // L'utilisateur a changé : on recharge les infos (whois)
      this.updateWhoisData();
    }
  },
  created() {
    // Bouton « Plus d'infos » supprimé : on affiche les infos (whois) par défaut
    this.updateWhoisData();
  },
  methods: {
    openQuery() {
      this.sidebarState.showNicklist();
      let buffer = this.$state.addBuffer(this.network.id, this.user.nick);
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    joinChannel(name) {
      // Clic sur une pilule salon : rejoint si besoin, puis bascule dessus.
      let buffer = this.$state.addBuffer(this.network.id, name);
      if (buffer && !buffer.joined) {
        this.network.ircClient.join(name);
      }
      this.sidebarState.showNicklist();
      this.$state.setActiveBuffer(this.network.id, buffer.name);
      if (this.$state.ui.is_narrow) {
        this.$state.$emit('userbox.hide');
      }
    },
    updateWhoisData() {
      this.whoisRequested = true;
      this.whoisLoading = true;
      this.network.ircClient.whois(this.user.nick, () => {
        this.whoisLoading = false;
      });
      // Filet de sécurité : si le whois ne répond pas, on affiche quand même le
      // profil après 4 s (évite un spinner infini). this.setTimeout est le mixin
      // auto-nettoyé (cf. main.js).
      this.setTimeout(() => {
        this.whoisLoading = false;
      }, 4000);
    }
  }
};
window._app_exports = window._app_exports || {};
if(!window._app_exports["components"]) window._app_exports["components"] = {};
window._app_exports["components"]["UserBox"]
window._app_exports.components.UserBox = exports.default ? exports.default : exports;
